import { AppSettings } from 'apprise-core/settings'
import { createProvider } from 'apprise-frontend-core/state/factory'
import { SettingsModule } from 'apprise-frontend-streams/settings/model'



export const [SettingsModuleProvider, useRegisteredModules] = createProvider({
    all: [] as SettingsModule[] 

})



export const [SettingsClientCache, useSettingsClientCache] = createProvider({
    all:{} as  AppSettings
})

